import { render, staticRenderFns } from "./addEditDiscount.vue?vue&type=template&id=b0894d2c"
import script from "./addEditDiscount.vue?vue&type=script&lang=js"
export * from "./addEditDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports